import { ArgumentsCamelCase } from 'yargs'
import { getCCLClient } from '../../getCCLClient'
import { input } from '@inquirer/prompts'
import { checkIfNewerVersionAvailableAndLog, updateCustomComponentLibraryConfig } from '../../util'

export const initCommand = async (argv: ArgumentsCamelCase<{ 'skip-updates-check': boolean, header?: string[] }>) => {
  const ccApi = await getCCLClient(false, argv.header)
  const label = (await whatName()).trim()
  const name = camelCaseify(label)
  const description = await whatDescription()

  // We can let users specify these if it becomes a clear need, for now we just set defaults.
  const entryPoint = 'src/index.tsx'
  const outputPath = 'dist'

  console.log('Creating new library in the Retool backend..')
  await ccApi.customComponentLibrariesPost({
    customComponentLibrariesPostRequest: { name, description, label },
  })

  console.log('...Succesfully made new library!')

  console.log('Writing updates to package.json')
  updateCustomComponentLibraryConfig({
    name,
    label,
    description,
    entryPoint,
    outputPath,
  })

  await checkIfNewerVersionAvailableAndLog(argv['skip-updates-check'])
}

const whatName = async (): Promise<string> => {
  const name = await input({
    validate: (input: string) => {
      if (input.trim().length === 0) {
        return 'A name is required.'
      }
      if (!/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(input.trim())) {
        return 'The name must only contain letters and numbers, and must start with a letter. Spaces are allowed'
      }

      return true
    },
    message: 'What name would you like to give your library of components (example: My Great Library)?',
  })

  return name
}

const camelCaseify = (nameWithSpaces: string) => {
  return nameWithSpaces
    .split(' ')
    .map((s) => (s.length > 0 ? s.substring(0, 1).toUpperCase().concat(s.slice(1)) : ''))
    .join('')
}

const whatDescription = async (): Promise<string> => {
  const description = await input({
    validate: (input: string) => {
      if (input.length > 1000) {
        return 'Description is too long (1000 character limit)'
      }

      return true
    },
    message:
      'What description would you like to give your library of components (example: A library full of great things.)?',
    default: '',
  })

  return description
}
